import dayjs from "dayjs";

export const handleDateKeyDown = (e) => {
    const input = e.target;
    const value = input.value;
    const cursor = input.selectionStart;
    const selectionEnd = input.selectionEnd;

    const allowedKeys = [
        "Backspace", "Tab", "ArrowLeft", "ArrowRight",
        "Delete", "Home", "End", "Enter", "Escape"
    ];
    if (allowedKeys.includes(e.key)) return;

    if (/^[a-zA-Z]$/.test(e.key)) {
        e.preventDefault();
        return;
    }

     if (cursor === 0 && selectionEnd === value.length && value.length > 0) {
        if (/^\d$/.test(e.key)) {
            e.preventDefault();
            
            input.value = '';
            
            if (e.key !== '0') {
                input.value = e.key;
            } else {
                input.value = '0';
            }
            
            const event = new Event('input', { bubbles: true });
            input.dispatchEvent(event);
            
            setTimeout(() => {
                input.setSelectionRange(input.value.length, input.value.length);
            }, 0);
            return;
        }
    }
    

    if (e.key === "/") {
        if ((value.match(/\//g) || []).length >= 2) {
            e.preventDefault();
            return;
        }
        
        if (value[cursor - 1] === "/") {
            e.preventDefault();
            return;
        }
        
        if (cursor !== 2 && cursor !== 5) {
            e.preventDefault();
            return;
        }
    }

    if (/^\d$/.test(e.key)) {
        e.preventDefault(); 
        
        let newValue = value;
        
        const digitsOnly = value.replace(/\D/g, '');
        const newDigits = digitsOnly + e.key;
        
        if (newDigits.length > 8) return;
        
        let formatted = '';
        if (newDigits.length <= 2) {
            let day = newDigits;
            if (day.length === 1 && parseInt(day) > 3) {
                day = '0' + day;
                formatted = day + '/';
            } else if (day.length === 2) {
                const dayNum = parseInt(day);
                if (dayNum < 1 || dayNum > 31) {
                    day = dayNum > 31 ? '31' : '01';
                }
                formatted = day + '/';
            } else {
                formatted = day;
            }
        } else if (newDigits.length <= 4) {
            let day = newDigits.slice(0, 2);
            let month = newDigits.slice(2);
            
            const dayNum = parseInt(day);
            if (dayNum < 1 || dayNum > 31) {
                day = dayNum > 31 ? '31' : '01';
            }
            
            if (month.length === 1 && parseInt(month) > 1) {
                month = '0' + month;
                formatted = day + '/' + month + '/';
            } else if (month.length === 2) {
                const monthNum = parseInt(month);
                if (monthNum < 1 || monthNum > 12) {
                    month = monthNum > 12 ? '12' : '01';
                }
                formatted = day + '/' + month + '/';
            } else {
                formatted = day + '/' + month;
            }
        } else {
            let day = newDigits.slice(0, 2);
            let month = newDigits.slice(2, 4);
            let year = newDigits.slice(4);
            
            const dayNum = parseInt(day);
            const monthNum = parseInt(month);
            
            if (dayNum < 1 || dayNum > 31) day = dayNum > 31 ? '31' : '01';
            if (monthNum < 1 || monthNum > 12) month = monthNum > 12 ? '12' : '01';
            
            formatted = day + '/' + month + '/' + year;
        }
        
        input.value = formatted;
        
        let newCursorPos;
        if (newDigits.length < 2) {
            newCursorPos = formatted.length;
        } else if (newDigits.length < 4) {
            newCursorPos = formatted.length;
        } else {
            newCursorPos = formatted.length;
        }
        
        const event = new Event('input', { bubbles: true });
        input.dispatchEvent(event);
        
        return;
    }
};

export const handleDateInput = (e) => {
    const input = e.target;
    let val = input.value;
    
    const cleanVal = val.replace(/[^\d/]/g, '');
    
    if (!cleanVal) return;
    
    const parts = cleanVal.split('/');
    const digits = cleanVal.replace(/\D/g, '');
    
    if (!cleanVal.includes('/') && digits.length <= 8) {
        let formatted = '';
        
        if (digits.length <= 2) {
            formatted = digits;
        } else if (digits.length <= 4) {
            formatted = digits.slice(0, 2) + '/' + digits.slice(2);
        } else {
            formatted = digits.slice(0, 2) + '/' + digits.slice(2, 4) + '/' + digits.slice(4, 8);
        }
        
        input.value = formatted;
        
        const event = new Event('input', { bubbles: true });
        input.dispatchEvent(event);
        return;
    }
    
    let day = parts[0] || '';
    let month = parts[1] || '';
    let year = parts[2] || '';
    
    if (day.length > 0) {
        let dayNum = parseInt(day);
        if (dayNum > 31) day = '31';
        else if (dayNum < 1) day = '01';
        
        if (day.length === 1 && dayNum > 3) {
            day = '0' + day;
        }
    }
    
    if (month.length > 0) {
        let monthNum = parseInt(month);
        if (monthNum > 12) month = '12';
        else if (monthNum < 1) month = '01';
        
        if (month.length === 1 && monthNum > 1) {
            month = '0' + month;
        }
    }
    
    if (year.length > 4) year = year.slice(0, 4);
    
    let formatted = day;
    if (month) formatted += '/' + month;
    if (year) formatted += '/' + year;
    
    input.value = formatted;
};

export const handleDateBlur = (e, onValidDate) => {
    let v = e.target.value;
    if (!v) return;

    const [d, m, y] = v.split("/");
    if (!d || !m || !y) return;

    const final = `${d.padStart(2, "0")}/${m.padStart(2, "0")}/${y.padStart(4, "0")}`;
    const obj = dayjs(final, "DD/MM/YYYY");

    if (obj.isValid()) {
        onValidDate(obj.toDate());
        e.target.value = final;
    } else {
        e.target.value = '';
    }
};

export const blockPaste = (e) => e.preventDefault();


const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

export const handleDateInputDebounced = debounce(handleDateInput, 50);